import React from 'react';
import { Form, useForm } from 'react-hook-form';
import * as VisuallyHidden from '@radix-ui/react-visually-hidden';
import * as ScrollArea from '@radix-ui/react-scroll-area';
import { SearchIcon } from 'lucide-react';

import { SearchFormProps } from './search-form.props';
import SearchResult from './_components/search-result';
import DefaultSearchForm from './_components/default-search-form';
import { Input } from '../../ui/input';

const SearchForm = () => {
  const inputRef = React.useRef<HTMLInputElement>(null);
  const [searchQuery, setSearchQuery] = React.useState('');

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchQuery = e.target.value;
    setSearchQuery(searchQuery);
  };

  React.useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <>
      <form className='flex items-center relative'>
        <VisuallyHidden.Root>
          <label htmlFor='search-modal'>Search</label>
        </VisuallyHidden.Root>
        <SearchIcon className='absolute left-2.5 top-2 h-4 w-4 text-muted-foreground' />
        <Input
          placeholder='search'
          className='pl-8 h-8 mr-8 focus-visible:ring-offset-1 focus-visible:ring-1'
          type='search'
          placeholder='Search'
          aria-label='Search'
          defaultValue={searchQuery}
          onChange={(e) => onChange(e)}
          ref={inputRef}
        />
      </form>
      <ScrollArea.Root className='max-h-[calc(85vh-44px)] mb-5'>
        <ScrollArea.Viewport className='h-full w-full'>
          {searchQuery && searchQuery.length > 1 ? <SearchResult searchQuery={searchQuery} /> : <DefaultSearchForm setSearchQuery={setSearchQuery} />}
        </ScrollArea.Viewport>
        <ScrollArea.Scrollbar
          className='flex h-full w-2 touch-none select-none border-l border-l-transparent p-[1px] transition-colors'
          orientation='vertical'
        >
          <ScrollArea.Thumb className='relative flex-1 rounded-full bg-slate-300' />
        </ScrollArea.Scrollbar>
        <ScrollArea.Scrollbar
          className='flex h-2.5 touch-none select-none flex-col border-t border-t-transparent p-[1px] transition-colors'
          orientation='horizontal'
        >
          <ScrollArea.Thumb className='relative flex-1 rounded-full bg-slate-300' />
        </ScrollArea.Scrollbar>
        <ScrollArea.Corner className='bg-blackA5' />
      </ScrollArea.Root>
    </>
  );
};
export default SearchForm;
